var EventEmitterMixin = require("../../mixins/event-emitter.mixin");
var WishlistEntry = require("./wishlist-entry");

var WishlistTable = function () {
    var self = this;
    var $currentContext = $();

    var classMap = {
        addToCartToggle: ".js-wishlist-table__add-to-cart-toggle"
    };

    var moduleOptions = {};

    var wishlistEntriesList = [];

    var $addToCartToggle;

    this.getEntries = function() {
        return wishlistEntriesList;
    }

    function setFormattedPrice(entry, price) {
        var formattedPrice = `${ moduleOptions.currency }${ price }`;
        entry.setPrice(formattedPrice);
    }

    function setTierPrice(entry, format) {
        var postData = {
            formatId: format.id,
            priceCodeId: format.priceCodeId,
            quantity: 1
        };

        $.ajax({
            cache: false,
            type: "POST",
            url: "/nop/WidgetCharge/GetCharge",
            data: postData,
            complete: function (data) {
                var price = data.responseJSON.charge.toFixed(2);
                setFormattedPrice(entry, price);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                alert("An error has occurred.");
            },
            traditional: true
        });
    }

    function handleFormatChange(entry, format) {
        if (!moduleOptions.isReadonly) {
            var postData = {
                formatId: format.id,
                productId: format.productId
            };

            $.ajax({
                cache: false,
                type: "POST",
                url: "/nop/ShoppingCart/UpdateProductFormat",
                data: postData,
                error: function (_, message) {
                    alert("An error has occurred: " + message);
                },
                traditional: true
            });
        }
        
        if (!format.hasTierPrice) {
            setFormattedPrice(entry, format.unitPrice);
        } else {
            setTierPrice(entry, format);
        }
    }

    function handleEntryRemoved() {
        self._raiseEvent("entry-removed");
    }

    function handleAddToCartToggleChange() {
        var value = $addToCartToggle.prop("checked");
        wishlistEntriesList.forEach(entry => {
            entry.setAddToCartMarker(value);
        });
    }

    function bindEvents() {
        wishlistEntriesList.forEach(entry => {
            entry
                .on("format-changed", function (format) {
                    handleFormatChange(entry, format);
                })
                .on("entry-removed", function() {
                    handleEntryRemoved();
                })
                .initValue();
        });

        $addToCartToggle.on("change", function () {
            handleAddToCartToggleChange();
        })
    }

    function parseContext() {
        var $wishlistEntries = $(WishlistEntry.SELECTOR, $currentContext);
        $wishlistEntries.each((i, el) => {
            var $entryContext = $(el);
            var wishlistEntry = new WishlistEntry();
            wishlistEntry.init($entryContext);
            wishlistEntriesList.push(wishlistEntry);
        });

        $addToCartToggle = $(classMap.addToCartToggle, $currentContext);
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);

        parseContext();
        bindEvents();
    };
};

Object.assign(WishlistTable.prototype, new EventEmitterMixin());

Object.defineProperty(WishlistTable, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-wishlist-table"
});

module.exports = WishlistTable;
